import { Component } from 'preact';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import style from './styles/CustomDropDown.scss';

/**
 * @property {boolean} state.open
 */
export default class CustomDropDown extends Component {
	state = {
		open: false
	};

	getMenuModifiers = (maxHeight) => ({
		setMaxHeight: {
			enabled: true,
			fn: (data) => ({
				...data,
				styles: {
					...data.styles,
					overflow: 'auto',
					maxHeight
				}
			})
		}
	});

	toggle = () => {
		this.setState({
			open: !this.state.open
		});
		// Force update is necessary, because we must trigger re-render of the dropdown toggle
		// which will gain aria-expanded attribute - which is necessary for the keyDown navigation
		this.forceUpdate();
	};

	render = ({ children, title, className, maxHeight = 300 }, { open }) => (
		<Dropdown isOpen={open} toggle={this.toggle} className={`${style['custom-dropdown']} ${className}`}>
			<DropdownToggle caret color="primary">
				{title}
			</DropdownToggle>
			<DropdownMenu modifiers={this.getMenuModifiers(maxHeight)}>
				{children}
			</DropdownMenu>
		</Dropdown>
	)
}



// WEBPACK FOOTER //
// ./components/form/dropdown/CustomDropDown.js